/**
 * Shell overlay host id — sibling of `#root` inside the shared `#app-frame`.
 * Kept outside React's createRoot mount so platform overlays can stack above
 * the application tree without being constrained by module-local z-indexes.
 */
export const OVERLAY_PORTAL_HOST_ID = 'hibro-overlays';

/**
 * Resolve the platform default Portal container for `@hibro/ui-client`.
 * Prefers `#hibro-overlays`; falls back to `document.body` when the host is absent.
 */
export function resolveOverlayPortalContainer(
  doc: Document = document,
): HTMLElement {
  return doc.getElementById(OVERLAY_PORTAL_HOST_ID) ?? doc.body;
}
